import { Tab } from '../../../../../views/active-orders';

export default {
  title: 'Painel do restaurante',
  tabs: {
    [Tab.OngoingOrders]: 'Preparar agora',
    [Tab.FutureOrders]: 'Futuros',
    [Tab.CompleteOrders]: 'Concluídos',
  },
  buttons: {
    order_history: 'Histórico de pedidos',
  },
  feedback: {
    future_orders_alert: '⚠️ Não prepare ainda – iremos avisar quando deve começar.',
  },
};
